import React, { useEffect, useState } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import './CreateProduct.css';
import {
    makeStyles, Paper, Button, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, Divider
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import clsx from 'clsx';
import classNames from 'classnames';
import { convertToRaw, EditorState, RichUtils } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { newEvent } from '../Models/ProductsModel';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CustomAlert from '../CustomAlert';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { createPharmaEventsDocument } from '../../Backend/firebase/pharma-events';
import { EntryFeeInputRow } from './EntryFeeInputRow';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function CreatePharmaEvents() {
    const { register, handleSubmit, errors, reset } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [eventDescription, setEventDescription] = useState(() => EditorState.createEmpty());
    const [aboutThePharmaEvents, setAboutThePharmaEvents] = useState(() => EditorState.createEmpty());
    const [eligibilityCriteria, setEligibilityCriteria] = useState(() => EditorState.createEmpty());
    const [termsAndConditions, setTermsAndConditions] = useState(() => EditorState.createEmpty());
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [lastDateOfRegistration, setLastDateOfRegistration] = useState(new Date())
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();
    const [isEntryFree, setIsEntryFree] = useState('Free');
    const [entryFeeFields, setEntryFeeFields] = useState([
        {
            uniqueId: "",
            entryCategory: "",
            entryFees: "",
        }
      ]);

    const onSubmit = async (data) => {
        setIsLoading(true);
        const eventDescriptionValue = convertToRaw(eventDescription.getCurrentContent());
        const aboutThePharmaEventsValue = convertToRaw(aboutThePharmaEvents.getCurrentContent());
        const eligibilityCriteriaValue = convertToRaw(eligibilityCriteria.getCurrentContent());
        const termsAndConditionsValue = convertToRaw(termsAndConditions.getCurrentContent());
        // if (eventDescription.getCurrentContent().hasText()) {
            newEvent.userId = userData.uid;
            newEvent.eventName = data.eventName;
            newEvent.eventType = data.eventType;
            newEvent.modeOfEvent = data.modeOfEvent;
            newEvent.eventCategory = "Pharma Events";
            newEvent.location = data.location;
            newEvent.organizer = data.organizer;
            newEvent.phone = data.phone;
            newEvent.email = data.email;
            newEvent.startDate = startDate;
            newEvent.endDate = endDate;
            newEvent.lastDateOfRegistration = lastDateOfRegistration;
            newEvent.eventSubmissionURL = data.eventSubmissionURL;
            newEvent.expectedNumberOfAttendees = data.expectedNumberOfAttendees;
            newEvent.eventImage = null
            newEvent.eventDescription = String(JSON.stringify(eventDescriptionValue));
            newEvent.aboutThePharmaEvents = String(JSON.stringify(aboutThePharmaEventsValue));
            newEvent.eligibilityCriteria = String(JSON.stringify(eligibilityCriteriaValue));
            newEvent.termsAndConditions = String(JSON.stringify(termsAndConditionsValue));
            newEvent.nameOfTheDelegate = data.nameOfTheDelegate;
            newEvent.designation = data.designation;
            newEvent.companyAndOrganizations = data.companyAndOrganizations;
            newEvent.isEntryFree = isEntryFree;
            newEvent.entryFeeFields = entryFeeFields;
            newEvent.eventStatus = 'New';
            try {
                var event = createPharmaEventsDocument(newEvent);
                if (event) {
                    setNotificationMessage('Event created successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    reset();
                    setEventDescription(EditorState.createEmpty());
                    setIsLoading(false);
                    setTimeout(routeToPages, 2000);
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-pharma-events');
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-pharma-events');
            }
        // } else {
        //     setNotificationMessage("Please enter event description!");
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/pharma-events';
    }

    const onEditorStateChange = (editorState) => {
        setEventDescription(editorState);
    };

    const onEditorAboutThePharmaEventsStateChange = (editorState) => {
        setAboutThePharmaEvents(editorState);
    };

    const onEditorEligibilityCriteriaStateChange = (editorState) => {
        setEligibilityCriteria(editorState);
    };

    const onEditorTermsAndConditionsStateChange = (editorState) => {
        setTermsAndConditions(editorState);
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    }

    const handleLastDateOfRegistrationChange = (e) => {
        setLastDateOfRegistration(e.target.value);
    }

    const handleIsEntryFreeChange = (event) => {
        setIsEntryFree(event.target.value);
    };

    const handleEntryFeesAdd = () => {
        setEntryFeeFields([
            ...entryFeeFields,
            {
                uniqueId: "",
                entryCategory: "",
                entryFees: "",
            }
        ])
    }
    const handleEntryFeesRemove = (index) => {
        if (entryFeeFields.length !== 1) {
            const values = [...entryFeeFields]
            values.splice(index, 1)
            setEntryFeeFields(values)
        }
    }
    const handleEntryFeesChange = (event, index) => {
        const uniqueId = uuidv4();
        const values = [...entryFeeFields]
        values[index][event.target.name] = event.target.value
        values[index]["uniqueId"] = uniqueId

        setEntryFeeFields(values)
    }

    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating New event Event." />
                    <title>Create New Pharma Events | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                Name of the Pharma Events <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventName })}
                                    name="eventName" autoComplete="none"
                                    ref={register({ required: 'Please enter Name of the Pharma Events!' })} />
                                <small className="form-text text-danger">{errors.eventName && errors.eventName.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Name of the Organizer <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.organizer })}
                                    name="organizer" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Name of the Organizer!' })} />
                                <small className="form-text text-danger">{errors.organizer && errors.organizer.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Contact Number of Organizer <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.phone })}
                                    name="phone" autoComplete="none"
                                    ref={register({ required: 'Please enter Contact Number of Organizer!' })} />
                                <small className="form-text text-danger">{errors.phone && errors.phone.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Email of Organizer <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.email })}
                                    name="email" autoComplete="none"
                                    ref={register({ required: 'Please enter Contact Email of Organizer!' })} />
                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Start Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="startDate"
                                    value={startDate}
                                    name='startDate'
                                    cssclassName="e-outline"
                                    onChange={(e) => handleStartDateChange(e)}
                                    ref={register({ required: 'Please enter Start Date!' })}
                                />
                                <small className="form-text text-danger">{errors.startDate && errors.startDate.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                End Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="endDate"
                                    value={endDate}
                                    name='endDate'
                                    cssclassName="e-outline"
                                    onChange={(e) => handleEndDateChange(e)}
                                    ref={register({ required: 'Please enter End Date!' })}
                                />
                                <small className="form-text text-danger">{errors.endDate && errors.endDate.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Last Date Of Registration <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="lastDateOfRegistration"
                                    value={lastDateOfRegistration}
                                    name='lastDateOfRegistration'
                                    cssclassName="e-outline"
                                    onChange={(e) => handleLastDateOfRegistrationChange(e)}
                                    ref={register({ required: 'Please enter End Date!' })}
                                />
                                <small className="form-text text-danger">{errors.endDate && errors.endDate.message}</small>
                            </div>
                            <div className="col-md-8 mb-2">
                                Location <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.location })}
                                    name="location" autoComplete="none"
                                    ref={register({ required: 'Please enter Location!' })} />
                                <small className="form-text text-danger">{errors.location && errors.location.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Expected Number of attendees <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.expectedNumberOfAttendees })}
                                    name="expectedNumberOfAttendees" autoComplete="none"
                                    ref={register({ required: 'Please enter Expected Number of attendees!' })} />
                                <small className="form-text text-danger">{errors.expectedNumberOfAttendees && errors.expectedNumberOfAttendees.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Type of Event <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventType })}
                                    name="eventType" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter event Type!' })} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Mode Of Event <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.modeOfEvent })} aria-label="Default select example"
                                    name="modeOfEvent" ref={register({
                                        required: 'Please select Mode of Events!',
                                        validate: {
                                            defaultValue: value => value !== "Select Mode Of Event" || 'Please select mode of Event!'
                                        }
                                    })} defaultValue="Select Event Type">
                                    <option value="Online">Online</option>
                                    <option value="Offline">Offline</option>
                                </select>
                            </div>
                            <div className="col-md-12 mb-2">
                                Event Submission URL <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventSubmissionURL })}
                                    name="eventSubmissionURL"
                                    autoComplete="none"
                                    placeholder="Event Google Form URL"
                                    ref={register({ required: 'Please enter Event Submission URL (Google Form)!' })}
                                />
                                <small className="form-text text-danger">{errors.eventSubmissionURL && errors.eventSubmissionURL.message}</small>
                            </div>
                            <h3 className="mt-4 border__bottom">Descriptions</h3>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>About the Pharma Events</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={aboutThePharmaEvents} onEditorStateChange={onEditorAboutThePharmaEventsStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Eligibility Criteria</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eligibilityCriteria} onEditorStateChange={onEditorEligibilityCriteriaStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Terms and Conditions</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={termsAndConditions} onEditorStateChange={onEditorTermsAndConditionsStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <h3 className="mt-4">Delegates</h3>
                            <div className="col-md-6 mb-2">
                                <b>Name of the delegate</b>
                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                    name="nameOfTheDelegate"
                                    autoComplete="none"
                                    placeholder="Name of the delegate"
                                    ref={register()}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                <b>Designation</b>
                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                    name="designation"
                                    autoComplete="none"
                                    placeholder="Designation"
                                    ref={register()}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                <b>Company/Organizations</b>
                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                    name="companyAndOrganizations"
                                    autoComplete="none"
                                    placeholder="Company/Organizations"
                                    ref={register()}
                                />
                            </div>
                            <div className="col-md-12 mt-4 mb-2 mr-3">
                                <b>Other Details</b>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eventDescription} onEditorStateChange={onEditorStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <h4 className="mt-4 border__bottom">Entry Fees</h4>
                            <div className="col-md-12 mb-2 mr-3">
                                <div className="col-md-10 mb-2">
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label="isEntryFree" name="isEntryFree" row>
                                            <FormControlLabel value="Free" control={<Radio checked={isEntryFree === 'Free'}
                                                onChange={handleIsEntryFreeChange}
                                                value="Free"
                                                className="skilsForm__radioBtn" />}
                                                label="Free"
                                                name="isEntryFree"
                                                inputRef={register}
                                                className="updateProduct__hoursPerWeek" />
                                            <FormControlLabel value="Entry Fees reqiured" control={<Radio checked={isEntryFree === 'Entry Fees reqiured'}
                                                onChange={handleIsEntryFreeChange}
                                                value="Entry Fees reqiured"
                                                className="skilsForm__radioBtn" />}
                                                label="Entry Fees reqiured"
                                                name="isEntryFree"
                                                inputRef={register}
                                                className="updateProduct__hoursPerWeek" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                <div className="col-md-2 mb-2"></div>
                            </div>
                            <div className="row mb-3">
                                {entryFeeFields.map((item, index) => (
                                    <>
                                        <div key={index}>
                                            <EntryFeeInputRow
                                                errors={errors}
                                                register={register}
                                                inputFields={entryFeeFields}
                                                index={index}
                                                item={item}
                                                handleForm={null}
                                                handleChange={handleEntryFeesChange}
                                                handleRemove={handleEntryFeesRemove}
                                                handleAdd={handleEntryFeesAdd}
                                            />
                                        </div>
                                        <Divider />
                                    </>
                                ))}
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Create Event'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} verticalPosition="bottom" horizontalPosition="center" />
        </>
    )
}

export default CreatePharmaEvents

